<template>
  <div class="relative">
    <slot
      name="activator"
      :toggle="toggle"
      :is-open="value"
    />

    <transition
      enter-active-class="transition-opacity duration-200"
      leave-active-class="transition-opacity duration-200"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
      @before-enter="onEnter"
      @after-leave="onLeave"
    >
      <div
        v-show="value"
        ref="content"
        class="z-20"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';

export default {
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },

  data() {
    return {
      popper: null,
    };
  },

  watch: {
    value() {
      if (this.value) {
        setTimeout(() => {
          document.body.addEventListener('click', this.clickDom);
        });
      } else {
        document.body.removeEventListener('click', this.clickDom);
      }
    },
  },

  mounted() {
    document.body.appendChild(this.$refs.content);
  },

  beforeDestroy() {
    document.body.removeChild(this.$refs.content);
  },

  methods: {
    clickDom(evt) {
      if (this.value && !this.$refs.content.contains(evt.target)) {
        this.$emit('input', false);
      }
    },
    toggle() {
      this.$emit('input', !this.value);
    },

    onEnter() {
      this.popper = createPopper(this.$el, this.$refs.content, {
        placement: this.placement,
        strategy: 'fixed',
      });
    },

    onLeave() {
      if (this.popper) {
        this.popper.destroy();
      }
    },
  },
};
</script>
